/* jscs:disable maximumLineLength */
export default {
    config: {
        shareUrl: {
            default: {
                baseUrl: 'https://yandex.ru/chat',
                restUrl: '#/forward',
                params: {
                    text: {
                        options: ['title', 'url'],
                        separator: '\n'
                    }
                }
            }
        }
    },

    i18n: {
        az: 'Ð¯.ÐœÐµÑÑÐµÐ½Ð´Ð¶ÐµÑ€',
        be: 'Ð¯.ÐœÐµÑÑÐµÐ½Ð´Ð¶ÐµÑ€',
        en: 'Yandex.Messenger',
        hy: 'Yandex.Messenger',
        ka: 'Yandex.Messenger',
        kk: 'Ð¯.ÐœÐµÑÑÐµÐ½Ð´Ð¶ÐµÑ€',
        ro: 'Yandex.Messenger',
        ru: 'Ð¯.ÐœÐµÑÑÐµÐ½Ð´Ð¶ÐµÑ€',
        tr: 'Yandex.Messenger',
        tt: 'Ð¯.ÐœÐµÑÑÐµÐ½Ð´Ð¶ÐµÑ€',
        uk: 'Yandex.Messenger',
        uz: 'Yandex.Messenger'
    },

    color: '#03CECE'
};
